export const GetBkgLogo = (route) => {
    let bkg = '';
    if (route && route.includes('disney-adventure-world')) {
        bkg = 'bkg-logo-studios';
    }
    if (route && route.includes('park-disneyland')) {
        bkg = 'bkg-logo-park';
    }
    return bkg;
}